import React from "react";
import { IconButton as MuiIconButton, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

export default function IconSubmitButton(props) {
  const { children, onClick, ...other } = props;
  const classes = useStyles();
  const SubmitButton = (props) => <button {...props} type="submit" />;
  return (
    <MuiIconButton
      component="span"
      className={`${classes.root}`}
      onClick={onClick}
      component={SubmitButton}
      {...other}
    >
      {children}
    </MuiIconButton>
  );
}
